/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelServizioListItemDTO } from '../model/models';
import { ServiziListFilter } from '../model/models';
import { ServizioDTO } from '../model/models';
import { ServizioMensaOrarioAnnullamentoForm } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface GetServizioGestioneDetailRequestParams {
    idServizio: string;
}

export interface ListServiziGestioneRequestParams {
    filter: ServiziListFilter;
    pageable: Pageable;
}

export interface PatchServizioOrarioAnnullamentoRequestParams {
    idServizio: string;
    servizioMensaOrarioAnnullamentoForm: ServizioMensaOrarioAnnullamentoForm;
}


export interface ServiziServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Detail di un servizio con sottotipo inflated.
     * Audience: SUPERADMIN (qualsiasi), OP_COMUNE (solo se servizio.tipoPratica.comune.id ∈ comuniGestiti). Risposta: ServizioDTO Fase-14 (root + mensa annidato sse tipoServizio &#x3D; MENSA).
     * @endpoint get /api/v1/gestione/servizi/{id_servizio}
* @param requestParameters
     */
    getServizioGestioneDetail(requestParameters: GetServizioGestioneDetailRequestParams, extraHttpRequestParams?: any): Observable<ServizioDTO>;

    /**
     * Lista paginata cross-bando dei servizi role-scoped.
     * Audience: SUPERADMIN (vede tutti), OP_COMUNE (scope automatico sui propri comuniGestiti). Filtri opzionali: q, tipo_servizio, comune_id, tipo_pratica_id, tipologia_pratica, stato, include_chiusi. Default sort: tipoPratica.codice ASC, dataInizio DESC.
     * @endpoint get /api/v1/gestione/servizi
* @param requestParameters
     */
    listServiziGestione(requestParameters: ListServiziGestioneRequestParams, extraHttpRequestParams?: any): Observable<PagedModelServizioListItemDTO>;

    /**
     * Modifica l\&#39;orario massimo di annullamento pasto di un servizio mensa.
     * Audience: SUPERADMIN (qualsiasi), OP_COMUNE (solo sui propri comuniGestiti). Unica scrittura sulla configurazione mensa concessa a OP_COMUNE: il resto resta SUPERADMIN-only sulla sub-resource di bando. Il campo governa anche l\&#39;orario dei report pasti, generati cinque minuti dopo il cutoff. Valore nullo o vuoto &#x3D; nessun orario impostato (lo scheduler usa il default 09:00).
     * @endpoint patch /api/v1/gestione/servizi/{id_servizio}/mensa/orario-annullamento
* @param requestParameters
     */
    patchServizioOrarioAnnullamento(requestParameters: PatchServizioOrarioAnnullamentoRequestParams, extraHttpRequestParams?: any): Observable<ServizioDTO>;

}
